module.exports = __webpack_public_path__ + "static/media/pf8.e9e1b9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf8.png
// module id = 2668
// module chunks = 0